import { render, staticRenderFns } from "./tab-attribute.vue?vue&type=template&id=f36af13e&scoped=true&"
import script from "./tab-attribute.vue?vue&type=script&lang=js&"
export * from "./tab-attribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36af13e",
  null
  
)

export default component.exports